import { Typography } from '@trackman/web-shared-components';

import ReportPageHeader from './ReportPageHeader';
import { useTranslation } from 'react-i18next';

type Props = {
  playerName?: string;
  teamName?: string;
  sessionName?: string;
};

const PlayerReportHeader = ({ playerName, teamName, sessionName }: Props) => {
  const { t } = useTranslation();
  const sessionDate = sessionName?.split('|')[0];
  const sessionMatch = sessionName?.split('|')[1];

  return (
    <ReportPageHeader>
      <Typography variant='h2' component='div' color='#414141'>
        {playerName ?? t('Player’s name')}
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        |
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        {teamName ?? t('Team’s name')}
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        |
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        {sessionDate ?? t('Date')}
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        |
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        {sessionMatch ?? t('Match')}
      </Typography>
    </ReportPageHeader>
  );
};

export default PlayerReportHeader;
